import { useState } from "react";
import { QuickReviewListResponse } from "../../../../data-model/quickReviewModel";
import { QuickReviewTableData } from "../utils/quickReviewTableUtils";

/** Page size used for Quick Review board fetches (largest the endpoint accepts). */
export const QUICK_REVIEW_HITS_PER_PAGE = 100;

/** Represents the loading, data, and error state for the Quick Review board table. */
export interface QuickReviewOrdersState {
  data?: QuickReviewListResponse;
  loading?: boolean;
  error?: string;
  showinLineLoader?: boolean;
  totalCount?: number;
}

/**
 * Manages local state for the Quick Review board table: the raw board list
 * response (loading/data/error) and the derived table row data array.
 *
 * @returns State values and setters for quickReviewOrdersState and tableData
 */
export const useQuickReviewOrdersTableData = () => {
  const [tableData, setTableData] = useState<QuickReviewTableData[]>([]);
  const [quickReviewOrdersState, setQuickReviewOrdersState] =
    useState<QuickReviewOrdersState>({
      data: undefined,
      loading: false,
      error: undefined,
      showinLineLoader: false,
    });

  return {
    quickReviewOrdersState,
    setQuickReviewOrdersState,
    tableData,
    setTableData,
  };
};
